export default "__VITE_ASSET__CNb_Cvjw__"